<script>
export default {
  props: {
    info: {
      monthyear: "",
      full_name: "",
      department_name: "",
      workday: 0,
      workday_real: 0,
      leave: 0,
      learn: 0,
      sick: 0,
      maternity: 0,
      unpaid_leave: 0,
      isolation: 0,
    },
  },
};
</script>

<template>
  <div id="timesheet-general-info">
    <CRow class="row-container">
      <CCol sm="6">
        <CRow class="user-info">
          <div style="margin-top: 4px">
            <CImg
              :src="require('@/assets/images/no_avatar.png')"
              class="avatar-img"
            />
          </div>
          <CCol sm="9">
            <CRow>
              <span class="user-label">Nhân viên: </span>{{ info.full_name }}
            </CRow>
            <CRow class="info-row">
              <span class="user-label">Phòng ban: </span
              >{{ info.department_name }}
            </CRow>
            <CRow class="info-row">
              <span class="user-label">Bảng công: </span>Tháng
              {{ info.monthyear }}
            </CRow>
            <CRow class="info-row">
              <span class="user-label">Trạng thái:</span>
              <CBadge v-if="info.status == 2" color="primary">Đang chấm</CBadge>
              <CBadge v-if="info.status == 3" color="danger">Trả lại</CBadge>
              <CBadge v-if="info.status == 1" color="success">Đã duyệt</CBadge>
              <CBadge v-else-if="info.status == -1" color="warning"
                >Chờ duyệt</CBadge
              >
              <CBadge v-else-if="info.status == 5" color="danger"
                >Văn phòng trả</CBadge
              >
              <CBadge v-else-if="info.status == 6" color="success"
                >Gửi văn phòng</CBadge
              >
            </CRow>
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="3">
        <CRow class="info-row">
          <span class="result-label">Ngày công tháng: </span>{{ info.workday }}
        </CRow>
        <CRow class="info-row">
          <span class="result-label">Ngày công thực tế: </span
          >{{ info.workday_real }}
        </CRow>
        <CRow class="info-row">
          <span class="result-label">Nghỉ phép: </span>{{ info.leave }}
        </CRow>
        <CRow class="info-row">
          <span class="result-label">Học đào tạo: </span>{{ info.learn }}
        </CRow>
      </CCol>
      <CCol sm="3">
        <CRow class="info-row">
          <span class="result-label">Nghỉ ốm:</span> {{ info.sick }}
        </CRow>
        <CRow class="info-row">
          <span class="result-label">Nghỉ không lương: </span
          >{{ info.unpaid_leave }}
        </CRow>
        <CRow class="info-row">
          <span class="result-label">Thai sản: </span>{{ info.maternity }}
        </CRow>
        <CRow class="info-row">
          <span class="result-label">Nghỉ lý do khác: </span
          >{{ info.isolation }}
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>

<style lang="scss">
#timesheet-general-info {
  .avatar-img {
    width: 80px;
    height: 80px;
    border: 1px solid #cfcfcf;
    border-radius: 10px;
    margin-right: 10px;
  }
  .row-container {
    margin: 0px;
  }
  .user-info {
    min-width: 350px;
  }
  .user-label {
    width: 90px;
    font-weight: bold;
  }
  .result-label {
    width: 150px;
    font-weight: bold;
  }
  .info-row {
    margin-top: 2px;
  }
}
</style>
